import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { useViewabilityHandler, ViewabilityProvider } from '../../viewability/viewabilityHandler';

const componentConfigurationKey = 'postMainContent';

interface PostMainContentThemeProps {
  backgroundColor: string;
}

const styleForFixedComponentWidth = {
  maxWidth: '100%',
  minWidth: '100%',
  [MEDIA_BREAKPOINTS.large]: {
    paddingLeft: '80px',
    maxWidth: 'calc(100% - 80px)',
    minWidth: 'calc(100% - 80px)',
  },
};

const createStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
    margin: '0 auto',
    overflow: 'hidden',
    ...styleForFixedComponentWidth,
  },
});

export const PostMainContent: React.FunctionComponent = ({ children }) => {
  const { backgroundColor } = useTheme<PostMainContentThemeProps>(componentConfigurationKey);
  const postMainContentStyle = createStyle(backgroundColor);
  const ref = useViewabilityHandler(() => {
    window.mmClientApi = window.mmClientApi || [];
    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'article end',
      event_label: '',
    });
  }, 1);
  return (
    <ViewabilityProvider>
      <article ref={ref} className={css(postMainContentStyle.style)}>
        {children}
      </article>
    </ViewabilityProvider>
  );
};
